// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hoopa: PokeData = {
  "id": 720,
  "name": "hoopa",
  "height": 5,
  "weight": 90,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC,
    PokeType.GHOST
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "light-screen",
    "destiny-bond",
    "shadow-ball",
    "trick",
    "magic-coat",
    "skill-swap",
    "astonish",
    "nasty-plot",
    "zen-headbutt",
    "trick-room",
    "guard-split",
    "power-split",
    "wonder-room",
    "ally-switch",
    "phantom-force",
    "hyperspace-hole"
  ],
  "moves": [
    "psychic",
    "shadow-ball",
    "zen-headbutt",
    "phantom-force",
    "psywave",
    "shadow-sneak",
    "prismatic-cage",
    "psychic-fangs",
    "future-sight",
    "lick",
    "healing-wish",
    "soul-sacrifice",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 372,
    "item": null,
    "species": [
      {
        "name": "hoopa",
        "order": 720,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 91,
    "ability_power": 195
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
